// extracted by mini-css-extract-plugin
export default {"inputDepartamento":"stylesDepartamentos_inputDepartamento__Ci6mu"};